import React, { useState } from "react";

export const Accordion = ({ children }) => {
  return <div className="space-y-2">{children}</div>;
};

export const AccordionItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border rounded">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center p-3 font-medium text-left"
      >
        {title}
        <span>{isOpen ? "-" : "+"}</span>
      </button>
      {isOpen && (
        <div className="p-3 border-t text-gray-700 text-sm">
          {children}
        </div>
      )}
    </div>
  );
};
